export default __webpack_public_path__ + "static/media/icon_check.a4896c48.svg";